<script setup>
import { computed, ref } from 'vue';
import { usePage } from '@inertiajs/vue3';
import AutocompleteSearch from '@/Components/Search/AutocompleteSearch.vue';

const page = usePage();

const locale = computed(() => page.props.locale);
const siteName = computed(() => page.props.siteName);

const searchComponent = ref(null);
</script>

<template>
    <AutocompleteSearch
        ref="searchComponent"
        :locale
        :site-name
    />
</template>
